import { render, staticRenderFns } from "./WalletCreditCharge.vue?vue&type=template&id=1dd04037"
import script from "./WalletCreditCharge.vue?vue&type=script&lang=js"
export * from "./WalletCreditCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports